import * as React from 'react';
import { Dispatch } from 'redux';
import { CallHistoryMethodAction, push } from 'connected-react-router';
import MotionOpacity from '@components/motion/motion-opacity';
import styled from 'styled-components';
import { Available } from '@components/basics/available';
import { UnAvailable } from '@components/basics/unavailable';
// import SubscriptionData from './subscription-data.json';
import Button from '@components/actions/button';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
import { ListReleasesSummary } from '@webapp/store/release/action-creators';
import { CleanRelease } from '@webapp/store/release/action-creators';

import Annie from './images/annie.jpg';
import Ava from './images/image.jpg';
import Stronger from './images/stronger.jpg';
import Neon from './images/neon.jpg';
import Topartist from './images/topartist.jpg';
import Electric from './images/electric.jpg';
import Typography from '@components/basics/typography';
import { Translate } from 'react-localize-redux';
import BottomFixedUpgrade from './bottom-fixed-upgrade';
import {
  getProPlanPrice,
  getLabelPlanPrice,
} from '@webapp/store/products/selectors';
import { ProductExtraFeature } from '@services/product/types/prodct-extra-features';
import SubscriptionBoxCtrl from '@webapp/controllers/subscription/subscription-box';
import SquareImg from '@components/basics/artwork-img';
import Avatar from '@components/basics/avatar';
import { ArtistCover } from './images/artist';
import { TitleCover } from './images/title';
import { LeftArrow } from './images/arrow';
import ArrowIcon from '@components/basics/icons/arrow';
import Tooltip from '@components/basics/tooltip';

export interface subscriptionProps {
  className?: string;
  clientId: string;
  subscriptionId: string;
  getSummary: () => ListReleasesSummary;
}
interface stateProps {
  isMobile: boolean;
  goToPlans: (props: any) => CallHistoryMethodAction;
  cleanRelease: () => CleanRelease;
  push: (path: string) => CallHistoryMethodAction;
  extraFeatures: ProductExtraFeature[];
  proPlanPrice: number;
  getLabelPlanPrice: number;
}
const mapStateToProps = (state: AppState) => ({
  clientId: state.artist.active?.id || '',
  subscriptionId: state.subscription.current?.id || '',
  isMobile: state.ui.mobile,
  extraFeatures: state.products.productsExtraFeatures?.sort(
    (a, b) => a?.id - b?.id
  ),
  proPlanPrice: getProPlanPrice(state.products.list),
  getLabelPlanPrice: getLabelPlanPrice(state.products.list),
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSummary: () => dispatch(new ListReleasesSummary()),
  goToPlans: (props: any) =>
    dispatch(push(`/plans/${props.clientId}/${props.subscriptionId}`)),
  cleanRelease: () => dispatch(new CleanRelease()),
  push: (path: string) => dispatch(push(path)),
});
export const ReleaseSubscriptionPlan: React.FC<
  stateProps & subscriptionProps
> = (props) => {
  const { getSummary } = props;
  const buttonRef = React.useRef(null);
  const [visible, setVisible] = React.useState<boolean>(true);
  const [showTooltip, setShowTooltip] = React.useState<boolean>(false);
  // const theme = useTheme();
  React.useEffect(() => {
    window.addEventListener('scroll', isInViewport);
    return () => window.removeEventListener('scroll', isInViewport);
  }, []);
  React.useEffect(() => {
    getSummary();
  }, [getSummary]);

  function isInViewport() {
    const element: any = buttonRef.current;
    if (element) {
      const rect = element.getBoundingClientRect();

      if (rect.top <= 0) {
        setVisible(true);
        return;
      }

      setVisible(
        rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  }
  const continueToRelease = () => {
    props.cleanRelease();
    props.push('/release');
  };

  return (
    <MotionOpacity className={props?.className}>
      <SubscriptionPlanContainer>
        <UnderlinedTitle>
          <Typography className="left">
            <Translate id="RELEASE.SUBSCRIPTION_PLAN.PLANS" />
          </Typography>
          <Typography>01</Typography>
        </UnderlinedTitle>
        <Description>
          <Typography>
            <Translate id="RELEASE.SUBSCRIPTION_PLAN.DESCRIPTION_2" />
          </Typography>
        </Description>

        <Table>
          <RowHeader>
            <Typography className="main title-black">
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.HEADER.COMPARE" />
            </Typography>
            <div className="beginner">
              <Typography className="title title-black">
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.HEADER.BEGINNER" />
              </Typography>
              <div>
                <Typography className="tag">
                  <Translate id="RELEASE.SUBSCRIPTION_PLAN.HEADER.CURRENT" />
                </Typography>
              </div>
            </div>
            <Typography className="pro title-black">
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.HEADER.PRO" />
            </Typography>
          </RowHeader>
          {props.extraFeatures?.map((item: any) => (
            <Row key={item.id}>
              <RowItemHeader>
                <Typography> {item.title}</Typography>
                {item.subtitle ? (
                  <Typography className="subtitle wrapped">
                    {item.subtitle}
                  </Typography>
                ) : null}
              </RowItemHeader>
              <RowItem>
                {item.beginner.availableIcon ? <Available /> : null}
                {item.beginner.title ? (
                  <>
                    {item.title === 'Stores Included' ? (
                      <TooltipWrapper>
                        <Typography
                          onClick={() => setShowTooltip(!showTooltip)}
                          className="title pointer"
                        >
                          {item.beginner.title} (?)
                        </Typography>
                        <Tooltip right="30%" isOpen={showTooltip}>
                          <Typography>
                            Spotify, SoundCloud, Amazon, Boom play, TikTok,
                            Pandora, Instagram, YouTube Music
                          </Typography>
                        </Tooltip>
                      </TooltipWrapper>
                    ) : (
                      <Typography className="title">
                        {item.beginner.title}
                      </Typography>
                    )}
                    {item.beginner.subTitle ? (
                      <Typography className="subTitle">
                        {item.beginner.subTitle}
                      </Typography>
                    ) : null}
                  </>
                ) : null}
                {item.beginner.unAvailableIcon ? <UnAvailable /> : null}
              </RowItem>
              <RowItem>
                {item.pro.availableIcon ? <Available /> : null}
                {item.pro.title ? (
                  <>
                    <Typography className="title">{item.pro.title}</Typography>
                    {item.pro.subTitle ? (
                      <Typography className="subTitle">
                        {item.pro.subTitle}
                      </Typography>
                    ) : null}
                  </>
                ) : null}
                {item.pro.unAvailableIcon ? <UnAvailable /> : null}
              </RowItem>
            </Row>
          ))}
          <FooterRow>
            <RowItemHeader>
              <Typography className="bold">
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.TOTAL" />
              </Typography>
            </RowItemHeader>
            <RowItem>
              <Typography className="bold">
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.FREE" />
              </Typography>
            </RowItem>
            <RowItem className="row-3">
              <Typography className="title">
                <b>${props.proPlanPrice.toFixed(2)}</b>
                <span className="per">/m</span>
              </Typography>
              <Typography className="subTitle">
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.BILLED" />
              </Typography>
            </RowItem>
          </FooterRow>
          <ButtonContainer ref={buttonRef}>
            <Button
              className="dark-button"
              buttonType="secondary"
              onClick={continueToRelease}
            >
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_2.CONTINUE" />
            </Button>

            <Button
              buttonType="primary"
              className={props.className}
              onClick={() =>
                props.goToPlans({
                  clientId: props.clientId,
                  subscriptionId: props.subscriptionId,
                })
              }
            >
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_2.UPGRADE" />
            </Button>
          </ButtonContainer>
        </Table>
        {!visible && (
          <BottomFixedUpgrade continueToRelease={continueToRelease} />
        )}
        <LabelContainer>
          <UnderlinedTitle>
            <Typography className="left">
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.LABEL" />
            </Typography>
            <Typography>03</Typography>
          </UnderlinedTitle>

          <LableTitle>
            <Typography className="left">
              {' '}
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.LABEL.TITLE" />
            </Typography>
          </LableTitle>
          <div className="description">
            <ul>
              <li>
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.LABEL.DESCRPTION_1" />
              </li>
              <li>
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.LABEL.DESCRPTION_2" />
              </li>
            </ul>
          </div>
          {/* <div className="label-placeholder">
            <img src={Top} alt="label placeholder" />
            <img className="bottom" src={Bottom} alt="label placeholder" />
          </div> */}
        </LabelContainer>
        <ImageContainer>
          <div className="global-left">
            <div className="image-wrapper abs">
              <LeftArrow />
              <div>
                <div className="cover">
                  <Avatar className="avatar" src={Topartist} size={'100'} />
                  <ArtistCover className="circle" />
                </div>
                <div className="title">
                  <Typography className="text">Top Artist</Typography>
                  <TitleCover className={'circle'} />
                </div>
              </div>
            </div>
            <SubscriptionBoxCtrl
              title={'Annie Knight'}
              avatar={Annie}
              boxText={'5 releases'}
              hasDarkButton
            >
              <div></div>
            </SubscriptionBoxCtrl>
            <SubscriptionBoxCtrl
              hasDarkButton
              title={'Electric Stranger'}
              avatar={Electric}
              boxText={'3 releases'}
              opened
              className="second-left"
            >
              <div className="inner-content">
                <div className="each-content border">
                  <div className="left">
                    <SquareImg srcImg={Stronger} />
                    <div>
                      <Title type="section-title" weight="400">
                        Stronger Now
                      </Title>
                      <Typography
                        opacity=".5"
                        weight="400"
                        type="small"
                        color={'#4C4F59'}
                      >
                        Single
                      </Typography>
                    </div>
                  </div>
                  <div className="right">
                    <div>
                      <Title type="section-title" weight="400">
                        123,412
                      </Title>
                      <Typography
                        opacity=".5"
                        weight="400"
                        type="small"
                        color={'#4C4F59'}
                      >
                        Streams
                      </Typography>
                    </div>
                    <div>
                      <Title type="section-title" weight="400">
                        $562.4
                      </Title>
                      <Typography
                        opacity=".5"
                        weight="400"
                        type="small"
                        color={'#4C4F59'}
                      >
                        Earned
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="each-content">
                  <div className="left">
                    <SquareImg srcImg={Neon} />
                    <div>
                      <Title type="section-title" weight="400">
                        Neon World
                      </Title>
                      <Typography
                        opacity=".5"
                        weight="400"
                        type="small"
                        color={'#4C4F59'}
                      >
                        Album
                      </Typography>
                    </div>
                  </div>
                  <div className="right">
                    <div>
                      <Title type="section-title" weight="400">
                        546,211
                      </Title>
                      <Typography
                        opacity=".5"
                        weight="400"
                        type="small"
                        color={'#4C4F59'}
                      >
                        Streams
                      </Typography>
                    </div>
                    <div>
                      <Title type="section-title" weight="400">
                        $2,743.3
                      </Title>
                      <Typography
                        opacity=".5"
                        weight="400"
                        type="small"
                        color={'#4C4F59'}
                      >
                        Earned
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </SubscriptionBoxCtrl>
            <div className="absolute-image">
              <SubscriptionBoxCtrl
                hasDarkButton
                className="third-left"
                title={'Eva Rose'}
                boxText={''}
                opened
              >
                <div className="third-left-content"></div>
              </SubscriptionBoxCtrl>
            </div>
          </div>
          <div>
            <SubscriptionBoxCtrl
              hasDarkButton
              title={'O Sound'}
              avatar={Annie}
              boxText={'1 artist on roster'}
              opened
              whiteBg
            >
              <div className="outer-right">
                <Typography className="title">Artists (1/5)</Typography>
                <div className="input-container">
                  <div className="left">
                    <div className="circle"></div>
                    <Typography weight="700">Add a new artist?</Typography>
                  </div>
                </div>
                <div className="input-container">
                  <div className="left">
                    <Avatar src={Ava} />
                    <div>
                      <Title type="section-title" weight="400">
                        Eva Rose
                      </Title>
                      <Typography weight="400" type="small" color={'#AEB2BF'}>
                        5 releases
                      </Typography>
                    </div>
                  </div>
                  <div className="right">
                    <Typography className="text">32% split</Typography>
                    <ArrowIcon up color="dark" />
                  </div>
                </div>
                <div className="second-right">
                  <Typography className="operator-title">Operators</Typography>
                  <Typography className="caption">
                    Trusted members from your team that can help you run your
                    label. They can manage artist profiles and release music.
                  </Typography>
                  <div className="input-container">
                    <div className="left">
                      <div className="circle"></div>
                      <div>
                        <Title type="section-title" weight="400">
                          Operator Name
                        </Title>
                        <Typography weight="400" type="small" color={'#AEB2BF'}>
                          James K.
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SubscriptionBoxCtrl>
          </div>
        </ImageContainer>

        <div className="label-button">
          <div></div>
          <ButtonContainer>
            <div>
              <Typography className="title">
                <b>${props.getLabelPlanPrice.toFixed(2)}</b>
                <span className="per">/m</span>
              </Typography>
              <Typography className="subTitle">
                <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_1.BILLED" />
              </Typography>
            </div>

            <Button
              buttonType="primary"
              className={props.className}
              onClick={() => props.push('/plans-record-label')}
            >
              <Translate id="RELEASE.SUBSCRIPTION_PLAN.FOOTER_2.UPGRADE" />
            </Button>
          </ButtonContainer>
        </div>
      </SubscriptionPlanContainer>
    </MotionOpacity>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ReleaseSubscriptionPlan)`
  .continue-next {
    text-align: center;
    margin: 60px 0px;
    p {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  span {
    &.title-black {
      color: ${({ theme }) => theme.colors.pureBlackWhite};
    }
  }
  .dark-button {
    background: ${({ theme }) => theme.colors.inputBackgroundAlternate};
    span {
      color: ${({ theme }) => theme.colors.primary} !important;
    }
  }
  .pointer {
    cursor: pointer;
  }
`);
const TooltipWrapper = styled.div`
  position: relative;
`;
const ImageContainer = styled.div`
  position: relative;
  display: grid;
  gap: 0.5rem;
  pointer-events: none;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  .abs {
    position: absolute;
    bottom: 1rem;
    left: 18%;
  }
  .second-left {
    opacity: 0.6;
  }
  .third-left {
    opacity: 0.2;
    .third-left-content {
      min-height: 6rem;
    }
  }
  .second-right {
    opacity: 0.2;
  }
  .outer-right {
    .title {
      font-size: ${({ theme }) => theme.typography.sectionTitle};
      margin-bottom: 1rem;
    }
    .operator-title {
      font-size: ${({ theme }) => theme.typography.sectionTitle};
      margin-top: 1rem;
    }
    .caption {
      font-size: ${({ theme }) => theme.typography.span};
      margin-bottom: 1rem;
      color: ${({ theme }) => theme.colors.secondaryDark};
    }
    .input-container {
      opacity: 0.5;
      padding: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: ${({ theme }) => theme.colors.inputBackground};
      border-radius: 2px;
      margin-bottom: 0.5rem;
      .left,
      .right {
        display: flex;
        gap: 1rem;
        align-items: center;
        .circle {
          border-radius: 9999px;
          width: 24px;
          height: 24px;
          background-color: ${({ theme }) => theme.colors.secondary};
        }
        .text {
          color: ${({ theme }) => theme.colors.secondaryDark};
        }
      }
    }
  }
  .image-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: -5rem;
    .cover {
      position: relative;
      .circle {
        position: absolute;
        top: 0;
      }
      .avatar {
        margin-left: 0.7rem;
      }
    }
    .title {
      margin-top: 2rem;
      position: relative;
      .text {
        margin-left: 1rem;
        padding-top: 0.6rem;
      }
      .circle {
        position: absolute;
        top: 0;
      }
    }
  }
  .inner-content {
    .each-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      &.border {
        border-bottom: 0.5px solid #727476;
      }
      .left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
      }
      .right {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 2rem;
      }
    }
  }
`;

const Title = styled(Typography)`
  margin-bottom: 3px;
`;
const LabelContainer = styled.div`
  margin-top: 60px;
  .description {
    margin-top: 30px;
    ul {
      display: flex;
      justify-content: space-between;
      gap: 60px;
    }
    li {
      font-size: 18px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  .label-placeholder {
    position: relative;
    img {
      &.bottom {
        width: auto;
        left: 3rem;
        bottom: -4rem;
      }
      width: 100%;
    }
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  padding-bottom: 30px;
  padding-top: 30px;
  gap: 1.5rem;
  padding-right: 0rem;
  @media ${({ theme }) => theme.device.mobileL} {
    padding-right: 2rem;
  }
  .title,
  .subTitle {
    display: flex;
  }
`;
const LableTitle = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  .left {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 40px;
    font-weight: 400;
  }
`;
const Row = styled.div`
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px dashed rgba(139, 139, 139, 0.489292);
  padding-top: 20px;
  span {
    color: ${({ theme }) => theme.colors.pureBlackWhite};
  }
`;
const FooterRow = styled.div`
  display: flex;
  padding-bottom: 30px;
  padding-top: 30px;
  span {
    color: ${({ theme }) => theme.colors.pureBlackWhite};
  }
`;
const RowItem = styled.div`
  width: 30%;
  @media ${({ theme }) => theme.device.mobileL} {
    width: 25%;
  }
  text-align: center;
  margin-top: auto;
  margin-bottom: auto;
  .title {
    font-size: ${({ theme }) => theme.typography.h4};
    font-weight: 400;
    display: block;
  }
  .subTitle {
    font-size: ${({ theme }) => theme.typography.h4};
    font-weight: 400;
    display: block;
    opacity: 0.5;
  }
  .bold {
    font-weight: 700;
  }
  &.row-3 {
    .title {
      font-weight: 400;
      .per {
        opacity: 0.5;
      }
    }
    .subTitle {
      font-size: ${({ theme }) => theme.typography.span};
      opacity: 0.5;
    }
  }
`;
const RowItemHeader = styled.div`
  width: 40%;
  @media ${({ theme }) => theme.device.mobileL} {
    width: 50%;
  }
  font-size: ${({ theme }) => theme.typography.h3};
  font-weight: 600;
  margin-top: auto;
  margin-bottom: auto;
  .subtitle {
    &.wrapped {
      max-width: 20rem;
    }
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.typography.span};
    font-weight: 400;
    opacity: 0.5;
    display: block;
  }
  .bold {
    font-weight: 700;
  }
`;
const RowHeader = styled.div`
  display: flex;
  padding-bottom: 15px;
  border-bottom: 1px dashed rgba(139, 139, 139, 0.489292);
  .main {
    width: 40%;
    @media ${({ theme }) => theme.device.mobileL} {
      width: 50%;
    }
    font-size: ${({ theme }) => theme.typography.lpHeaderTitleSize};
    font-weight: 700;
  }
  .beginner,
  .pro {
    width: 30%;
    @media ${({ theme }) => theme.device.mobileL} {
      width: 25%;
    }
    text-align: center;
  }
  .beginner {
    .title {
      font-weight: 700;
      font-size: ${({ theme }) => theme.typography.sectionTitle};
      display: block;
      margin-bottom: 5px;
    }
    .tag {
      background-color: #f3da93;
      border-radius: 12px;
      padding: 3px 8px;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.black};
      display: inline;
    }
  }
  .pro {
    font-weight: 700;
    font-size: ${({ theme }) => theme.typography.sectionTitle};
  }
`;

const Table = styled.div`
  margin-top: 60px;
`;

const Description = styled.div`
  margin-top: 25px;
  span {
    display: block;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.primary};

    font-size: ${({ theme }) => theme.typography.h3};
    @media ${({ theme }) => theme.device.tablet} {
      font-size: ${({ theme }) => theme.typography.h2};
    }
    @media ${({ theme }) => theme.device.laptop} {
      font-size: ${({ theme }) => theme.typography.h2Bigger};
    }
    @media ${({ theme }) => theme.device.laptopL} {
      font-size: ${({ theme }) => theme.typography.h1Small};
    }
  }
`;
const SubscriptionPlanContainer = styled.div`
  max-width: none;
  padding: 24px 24px 55px;

  @media ${({ theme }) => theme.device.tablet} {
    padding: 55px;
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding: 90px 90px 110px;
  }

  @media ${({ theme }) => theme.device.laptopXL} {
    padding: 90px 180px 110px;
  }

  @media ${({ theme }) => theme.device.desktopL} {
    padding: 130px 320px;
  }
  .label-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label-title {
      opacity: 0.5;
      color: ${({ theme }) => theme.colors.pureBlackWhite};
      display: block;
    }
  }
`;
const UnderlinedTitle = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 25px;
  border-bottom: 1px solid #979797;
  span {
    font-size: ${({ theme }) => theme.typography.h3};
  }
  color: ${({ theme }) => theme.colors.primary};
  .left {
    font-weight: 700;
  }
`;
